module.exports = __webpack_public_path__ + "img/sign-up-study.223c99ec.png";